import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

export const SOCIAL_CAMPAIGN_CATEGORIES_QUERY_KEY = 'socialCampaignCategories';

export function useSocialCategories(params: {
	industry: Api.Industry;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
	select?: (categories: string[]) => string[];
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled: params.enabled,
		queryFn: async () => {
			return userSession.webServiceHelper.callAsync<string[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `template/${encodeURIComponent(params.industry)}/socialCategories`,
					impersonationContext: params.impersonationContext,
				}),
				'GET'
			);
		},
		queryKey: [SOCIAL_CAMPAIGN_CATEGORIES_QUERY_KEY, params.industry, params.impersonationContext],
		select: params.select,
		refetchOnWindowFocus: false,
	});
}
export const invalidateSocialCategoryTemplates = () => {
	reactQueryClient.invalidateQueries({ queryKey: [SOCIAL_CAMPAIGN_CATEGORIES_QUERY_KEY] });
};
